import clsx from "clsx"
import { JumbotronStyle } from "./jumbotron"


export const JumbotronContainer = ({
    children,
    isMobile,
    backgroundImage,
    jumbotronStyle,
    rounded,
  }: {
    children: React.ReactNode
    isMobile: boolean
    backgroundImage: string
    jumbotronStyle: JumbotronStyle | undefined
    rounded?: boolean
  }) => (
    <div
      className={clsx(
        isMobile ? 'block md:hidden' : 'hidden md:block',
        'flex-col',
        'pb-10',
        'md:pb-20',
        'bg-center',
        'flex',
        'items-center',
        'bg-cover',
        'bg-no-repeat',
        'bg-blend-multiply',
        `${jumbotronStyle?.backgroundColor ? `bg-${jumbotronStyle?.backgroundColor}` : ''}`,
        `${rounded ? 'rounded-lg' : ''}`,
      )}
      style={
        backgroundImage
          ? {
              backgroundImage: `url('${backgroundImage}')`,
            }
          : {}
      }
    >
      {children}
    </div>
  )